import React, { useState, useEffect } from 'react'
import API from 'common/logic/API'
import { Alert, Card } from 'react-bootstrap'
import BigSpinner from 'common/components/BigSpinner'
import ExpectedMovementsByTagTable from 'application/budget/plan/ExpectedMovementsByTagTable'
import ExpenseByTagBarChart from 'application/budget/ExpenseByTagBarChart'
import _ from 'lodash'
import { BudgetPlan } from 'types'

interface Props {
    currentPlan: BudgetPlan
}

function MonthlyOutlook({ currentPlan }: Props) {
    const [breakdown, setBreakdown] = useState<any>(null)
    const [expectedMovements, setExpectedMovements] = useState<any[] | null>(null)
    const [error, setError] = useState<string | null>(null)

    const refreshData = () => {
        setBreakdown(null)
        setExpectedMovements(null)
        API.multiple({
            breakdown: API.get(`/budget-plan/breakdown-by-tag/${currentPlan.validFrom}`),
            expectedMovements: API.get(`/expected-movements?month=${currentPlan.validFrom}`)
        })
            .then((response: any) => {
                setBreakdown(response.breakdown)
                setExpectedMovements(response.expectedMovements.results)
            }).catch((err: any) => {
                setError(err.message)
            })
    }

    useEffect(() => {
        refreshData()
    }, [currentPlan.id]) // eslint-disable-line react-hooks/exhaustive-deps

    if (error) {
        return <Alert variant="danger">{error}</Alert>
    }
    if (!breakdown) {
        return <BigSpinner />
    }

    const expectedMovementsByCurrency = _.groupBy(expectedMovements, (e: any) => e.currency.name)
    return <>
        <Card>
            <ExpectedMovementsByTagTable
                data={breakdown}
                expectedMovementsByCurrency={expectedMovementsByCurrency}
                refreshCallback={refreshData}
                currentPlan={currentPlan}
            />
        </Card>
        <Card className="mt-3">
            <ExpenseByTagBarChart data={breakdown.entries} />
        </Card>
    </>
}

export default MonthlyOutlook
